// 动态配置
export const BRAND_MODULE_ID = {
  nio:10071,
  alps:10189,
  fy:10642
}

export const ONLINE_URL = {
  nio: {
    dev: 'https://car-beauty-dev.nioint.com',
    test: 'https://car-beauty-test.nioint.com',
    stg: 'https://car-beauty-stg.nio.com',
    prod: 'https://car-beauty.nio.com',
  },
  alps: {
    dev: 'https://car-beauty-alps-dev.nioint.com',
    test: 'https://car-beauty-alps-test.nioint.com',
    stg: 'https://car-beauty-alps-stg.onvo.cn',
    prod: 'https://car-beauty-alps.onvo.cn',
  },
  fy: {
    dev: 'https://car-beauty-fy-dev.nioint.com',
    test: 'https://car-beauty-fy-test.nioint.com',
    stg: 'https://car-beauty-fy-stg.firefly.com.cn',
    prod: 'https://car-beauty-fy.firefly.com.cn',
  }
};
